import React, { useState, useEffect } from 'react';
import NiceModal from "@ebay/nice-modal-react";
import { useSelector } from 'react-redux';
import { DateTime, Interval, Duration } from 'luxon';
import HomeIcon from '@images/tournamentQuests/homeWhite.svg';
import WorkspacePremium from '@images/tournamentQuests/workspace_premium.svg';
import ThreeFrodobotToken from '@images/tournamentQuests/3d_frodobotToken.png';
import CalendarClockIcon from '@images/tournamentQuests/calendar_clock.svg';
import ScheduleIcon from '@images/tournamentQuests/schedule.svg';
import GamePassSplash from '@images/tournamentQuests/gamePass_splash.png';
import DriveTournamentIcon from '@images/tournamentQuests/driveTournament.svg';
import RulesIcon from '@images/tournamentQuests/rule.svg';
import { tournamentGamesJoin, tournamentGames, getQuests } from '@services/api';
import TournamentRuleModel from "@components/Modal/TournamentRuleModel"
import { toast } from 'react-toastify';

const TournamentQuests = ({ setSelectedOption }) => {
    const [tournamentGamesData, setTournamentGamesData] = useState([]);
    const [questData, setQuestData] = useState([]);
    const [loading, setLoading] = useState(true);
    const user = useSelector((state) => state?.setUserDetails?.user);

    useEffect(() => {
        init();
    }, []);

    const init = async () => {
        setLoading(true);
        const tournamentGamesData = await tournamentGames();
        const questData = await getQuests();
        console.log('questData: ', questData);
        if (tournamentGamesData?.tournament_games) {
            const tournamentSortingData = tournamentGamesData?.tournament_games.sort((a, b) => {
                return new Date(a.started_at) - new Date(b.started_at);
            });
            const questData = tournamentSortingData.filter((tournamentGame) => tournamentGame.game_type === 'quest');
            if (questData.length > 0) {
                setQuestData(questData);
            }
            const tournamentData = tournamentSortingData.filter((tournamentGame) => tournamentGame.game_type === 'tournament');
            if (tournamentData.length > 0) {
                setTournamentGamesData(tournamentData);
            }
        }
        setLoading(false);
    };

    const DateDisplay = (startedAt) => {
        const formattedDate = DateTime.fromISO(startedAt).toFormat('MMMM dd, h:mm a');
        return formattedDate;
    };

    const remainingTimeHandler = (startDate) => {
        const dateTime = DateTime.fromISO(startDate);
        if (!dateTime.isValid) {
            return 'Invalid date';
        }
        const now = DateTime.now();
        const interval = Interval.fromDateTimes(now, dateTime);
        if (!interval.isValid || interval.end <= now) {
            return 'Expired';
        }
        const remainingMillis = interval.length('milliseconds');
        const remainingDuration = Duration.fromMillis(remainingMillis);
        const remainingDays = Math.floor(remainingDuration.as('days'));
        const remainingHours = Math.floor(remainingDuration.as('hours') % 24);

        if (remainingDays === 0) {
            return `${remainingHours} hours`;
        } else if (remainingDays === 1) {
            return `${remainingDays} day ${remainingHours} hours`;
        } else {
            return `${remainingDays} days ${remainingHours} hours`;
        }
    };

    const registerHandler = async (tournamentGame) => {
        const tournamentGamesJoinRes = await tournamentGamesJoin(tournamentGame?.id);
        console.log('tournamentGamesJoinRes: ', tournamentGamesJoinRes);
        if (tournamentGamesJoinRes?.errors) {
            toast.error('Your interest has been successfully registered', { position: 'top-right' });
        } else {
            window.open(`${tournamentGame?.how_to_join}`);
            init();
        }
    };

    const registeredHandler = async (tournamentGame) => {
        window.open(`${tournamentGame?.how_to_join}`);
        // toast.error('Your are already registered on this tournament ', { position: 'top-right' });
    };

    const ruleTournamentHandler = (rules) => {
        NiceModal.show(TournamentRuleModel, { rules })
    }

    return (
        <div className="relative top-[26px] h-screen w-screen overflow-auto bg-[#FAFAFA]">
            <div className="w-full flex flex-col gap-[36px] p-[36px]">
                <button
                    className="w-[215px] flex pl-[8px] pr-[12px] py-[6px] items-start gap-[6px] rounded-[1000px] bg-[#000]"
                    onClick={() => setSelectedOption(null)}
                >
                    <img
                        src={HomeIcon}
                        alt="home icon"
                        className="w-[20px] h-[20px]"
                    />
                    <p className="text-[#FAFAFA] text-[16px] not-italic font-bold leading-[normal] tracking-[-0.32px]">
                        Go back to dashboard
                    </p>
                </button>
                <div className="w-full flex flex-col items-center gap-[36px]">
                    {loading ?
                        <div className="w-full flex justify-center">
                            <p className="text-[#000] text-[24px]">Loading...</p>
                        </div>
                        :
                        <>
                            <div className="flex items-center gap-[8px]">
                                <img
                                    src={WorkspacePremium}
                                    alt="workspace premium"
                                    className="w-[36px] h-[36px]"
                                />
                                <p className="text-[#000] text-[42px] not-italic font-semibold leading-[42px] tracking-[-2.52px]">
                                    Tournaments
                                </p>
                            </div>
                            <div className="w-full flex flex-col items-start gap-[64px]">
                                <div className="min-w-[70%] m-auto flex flex-col justify-center items-start gap-[16px]">
                                    {tournamentGamesData.length > 0 ? (
                                        tournamentGamesData.map((tournamentGame, index) =>
                                            !(remainingTimeHandler(tournamentGame.started_at) === 'Expired') &&
                                            <div
                                                className="w-full flex p-[8px] flex-col justify-center items-center gap-[16px] rounded-[32px] border-[2px] border-solid border-[#FFF] bg-[linear-gradient(180deg,_#FFF_0%,_#EBEBEB_100%)]"
                                                key={index}
                                            >
                                                <div className="w-full flex flex-col p-[16px] justify-between rounded-[16px] gap-[16px]">
                                                    <div className="w-full flex pb-[8px] justify-between items-center border-b-[1px] border-b-solid border-b-[#DDD]">
                                                        <div className="flex px-0 py-[4px] flex-col items-start gap-[8px]">
                                                            <p className="text-[#282828] text-[32px] not-italic font-semibold leading-[32px] tracking-[-1.92px]">
                                                                {tournamentGame.name}
                                                            </p>
                                                            <p className="w-[620px] text-justify text-[#727272] text-[18px] not-italic font-medium leading-[28px] tracking-[-0.72px]">
                                                                {tournamentGame.description}
                                                            </p>
                                                            <p className="text-[#000] text-right text-[18px] not-italic font-medium leading-[28px] tracking-[-0.72px]">
                                                                Until {DateDisplay(tournamentGame.started_at)}
                                                            </p>
                                                        </div>
                                                        <img
                                                            src={ThreeFrodobotToken}
                                                            alt="3 frodobots token"
                                                        />
                                                    </div>
                                                    <div className="w-full flex justify-between items-start">
                                                        <div className="flex items-start gap-[8px]">
                                                            {tournamentGame && tournamentGame.tournament_game_players.some(player => player.user_id === user.id) ? (
                                                                !(remainingTimeHandler(tournamentGame.started_at) === 'Expired') && (
                                                                    <button
                                                                        className="flex pl-[8px] pr-[12px] py-[6px] items-center gap-[6px] rounded-[1000px] border-[1px] border-solid border-[#393939] bg-[#393939]"
                                                                        onClick={() => registeredHandler(tournamentGame)}
                                                                    >
                                                                        <img
                                                                            src={DriveTournamentIcon}
                                                                            alt="3 frodobots token"
                                                                        />
                                                                        <p className="text-[#F3F3F3] text-[16px] not-italic font-semibold leading-[normal] tracking-[-0.64px]">
                                                                            Registered
                                                                        </p>
                                                                    </button>
                                                                )
                                                            ) : (
                                                                !(remainingTimeHandler(tournamentGame.started_at) === 'Expired') && (
                                                                    <button
                                                                        className="flex pl-[8px] pr-[12px] py-[6px] items-center gap-[6px] rounded-[1000px] border-[1px] border-solid border-[#25BD66] bg-[#008735]"
                                                                        onClick={() => registerHandler(tournamentGame)}
                                                                    >
                                                                        <img
                                                                            src={DriveTournamentIcon}
                                                                            alt="3 frodobots token"
                                                                        />
                                                                        <p className="text-[#F3F3F3] text-[16px] not-italic font-semibold leading-[normal] tracking-[-0.64px]">
                                                                            Register
                                                                        </p>
                                                                    </button>
                                                                )
                                                            )}
                                                            <button className='flex pl-[8px] pr-[12px] py-[6px] items-center gap-[6px] rounded-[1000px] border-[1px] border-solid border-[#727272] bg-[#000]' onClick={() => ruleTournamentHandler(tournamentGame.rules)}>
                                                                <img src={RulesIcon} alt='3 frodobots token' />
                                                                <p className='text-[#F3F3F3] text-[16px] not-italic font-semibold leading-[normal] tracking-[-0.64px]'>Rules</p>
                                                            </button>
                                                        </div>
                                                        <div
                                                            className={`flex px-[8px] py-0 justify-center items-center gap-[4px] rounded-[4px] ${remainingTimeHandler(tournamentGame.started_at) === 'Expired'
                                                                ? 'bg-[#888686]'
                                                                : 'bg-[#000]'
                                                                }`}
                                                        >
                                                            <img
                                                                src={ScheduleIcon}
                                                                alt="schedule icon"
                                                                className="w-[24px] h-[24px]"
                                                            />
                                                            <p className="text-[#F3F3F3] text-[24px] not-italic font-semibold leading-[normal] tracking-[-0.96px]">
                                                                {remainingTimeHandler(tournamentGame.started_at)}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                {tournamentGame.rewards.length > 0 && (
                                                    <div className="w-full flex px-[16px] py-[8px] justify-center items-start gap-[4px] rounded-tl-[8px] rounded-br-[24px] rounded-tr-[8px] rounded-bl-[24px] bg-[#DDD]">
                                                        <div className="w-full flex-col flex justify-center items-center gap-[8px]">
                                                            <div className="w-full flex flex-row justify-center">
                                                                <p className="text-[#282828] text-[16px] not-italic font-semibold leading-[normal] tracking-[-0.64px]">
                                                                    Rewards
                                                                </p>
                                                            </div>
                                                            <div className="flex flex-row justify-center items-center gap-[16px]">
                                                                {tournamentGame.rewards.length > 0 &&
                                                                    tournamentGame.rewards
                                                                        .sort((a, b) => {
                                                                            const positionOrder = { '1st': 1, '2nd': 2, '3rd': 3 };
                                                                            return positionOrder[a.position] - positionOrder[b.position];
                                                                        })
                                                                        .map((reward, index) => (
                                                                            <div
                                                                                className="flex flex-row h-[32px] px-[8px] py-0 justify-center items-center gap-[4px] rounded-[4px] bg-[#F3F3F3]"
                                                                                key={index}
                                                                            >
                                                                                <p className="text-[#727272] text-[20px] not-italic font-semibold leading-[16px] tracking-[-1.2px]">
                                                                                    {reward.position}:
                                                                                </p>
                                                                                <p className="text-[#727272] text-[20px] not-italic font-semibold leading-[16px] tracking-[-1.2px]">
                                                                                    {reward.reward_description}
                                                                                </p>
                                                                            </div>
                                                                        ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )) : (
                                        <div className="w-full flex justify-center">
                                            <p className="w-[40%] text-center text-[#000] text-[24px] not-italic font-bold leading-[normal] tracking-[-0.32px]">
                                                There are currently no tournaments scheduled. Please check back later or go to discord for more
                                                information.
                                            </p>
                                        </div>
                                    )}
                                </div>
                                <div className="w-full flex flex-col justify-center gap-[16px]">
                                    <div className="w-full flex justify-center items-center gap-[24px]">
                                        <div className="flex items-center gap-[16px]">
                                            <div className="flex items-center gap-[8px]">
                                                <img
                                                    src={CalendarClockIcon}
                                                    alt="calendar clock icon"
                                                />
                                                <p className="text-[#282828] text-[24px] not-italic font-semibold leading-[normal] tracking-[-0.96px]">
                                                    Daily Quests
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="min-w-[60%] flex justify-center items-start gap-[24px]">
                                        {questData.length > 0 ?
                                            questData.map((quest, index) => (
                                                <div
                                                    className="flex w-[280px] h-[250px] flex-col items-start"
                                                    key={index}
                                                >
                                                    <img
                                                        src={GamePassSplash}
                                                        alt="GamePassSplash icon"
                                                        className="w-full h-[74px]"
                                                    />
                                                    <div className="flex w-[280px] h-full p-[8px] flex-col justify-between items-center gap-[8px] rounded-[32px] border-[2px] border-solid border-[#FFF] bg-[#EBEBEB]">
                                                        <button className="flex w-[264px] h-[56px] px-[16px] py-[12px] justify-center items-center gap-[10px] rounded-[39px] bg-[#393939]">
                                                            <p className="text-[#FAFAFA] text-[20px] not-italic font-semibold leading-[20px] tracking-[-0.8px]">
                                                                {quest.name}
                                                            </p>
                                                        </button>
                                                        <div className='w-full flex justify-center'>
                                                            <p className="text-[#282828] text-center text-[16px] not-italic font-semibold leading-[normal] tracking-[-0.64px]">
                                                                {quest.description}
                                                            </p>
                                                        </div>
                                                        <div className="w-full flex px-[16px] py-[8px] flex-col items-center gap-[4px] rounded-tl-[8px] rounded-br-[24px] rounded-tr-[8px] rounded-bl-[24px] bg-[#DDD]">
                                                            <p className="text-[#282828] text-[16px] not-italic font-semibold leading-[normal] tracking-[-0.64px]">
                                                                Reward
                                                            </p>
                                                            <p className="text-[#282828] text-[13px] not-italic font-medium leading-[15px] tracking-[-0.52px] opacity-70">
                                                                TBC
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                            :
                                            <div
                                                className="flex w-[280px] h-[250px] flex-col items-start"
                                            >
                                                <img
                                                    src={GamePassSplash}
                                                    alt="GamePassSplash icon"
                                                    className="w-full h-[74px]"
                                                />
                                                <div className="flex w-[280px] h-full p-[8px] flex-col justify-between items-center gap-[8px] rounded-[32px] border-[2px] border-solid border-[#FFF] bg-[#EBEBEB]">
                                                    <button className="flex w-[264px] h-[56px] px-[16px] py-[12px] justify-center items-center gap-[10px] rounded-[39px] bg-[#393939]">
                                                        <p className="text-[#FAFAFA] text-[20px] not-italic font-semibold leading-[20px] tracking-[-0.8px]">
                                                            Coming Soon
                                                        </p>
                                                    </button>
                                                    <div className="w-full flex px-[16px] py-[8px] flex-col items-center gap-[4px] rounded-tl-[8px] rounded-br-[24px] rounded-tr-[8px] rounded-bl-[24px] bg-[#DDD]">
                                                        <p className="text-[#282828] text-[16px] not-italic font-semibold leading-[normal] tracking-[-0.64px]">
                                                            Reward
                                                        </p>
                                                        <p className="text-[#282828] text-[13px] not-italic font-medium leading-[15px] tracking-[-0.52px] opacity-70">
                                                            TBC
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
        </div>
    );
};

export default TournamentQuests;
